import { ComercioSubscriptionApi as Api } from "./comercio-subscription.api";

export class ComercioSubscriptionFacade {
  static isAfiliadoSubscribedToComercio(afiliadoId, comercioId) {
    return Api.isAfiliadoSubscribedToComercio(afiliadoId, comercioId);
  }

  static subscribe(afiliadoId, comercioId) {
    return Api.subscribe({ afiliadoId, comercioId });
  }

  static cancelSubscription(afiliadoId, comercioId) {
    return Api.cancelSubscription(afiliadoId, comercioId);
  }
}
